import React, { Component } from 'react'
import { normalizeColor } from 'utils/TagAppearanceHelper'
import cx from 'classnames'
import Tag from 'shared-web/src/components/Tag'
import 'styles/components/TagList.styl'

class TagList extends React.Component {
  render() {
    const { children, extraContentNode, afterTagsNode, tagIds, tagsById, tagClickFunc } = this.props
    return (
      <div className="TagList">
        {children}
        {extraContentNode}
        {_.map(tagIds, tagId => {
          const tag = tagsById.get(tagId)
          if (tag == null) {
            return
          }
          return <div
            className={cx({ canHover: !!tagClickFunc })}
            title={tag.name}
            key={`${tagId}`}>
              <Tag tag={normalizeColor(tag)} />
              {tagClickFunc && <div className="remove-tag" onClick={() => tagClickFunc && tagClickFunc([tag.id])}>X</div>}
            </div>
        })}
        {afterTagsNode}
      </div>
    )
  }
}

export default TagList



// WEBPACK FOOTER //
// ./src/scripts/components/TagList/component.js